<section class="section white-100" *ngIf="_getStartedData">
  <div class="section-container">
    <div class="section-discover-power-text padd-48">
      <div class="discover-power-content-basic align-items-c">
        <ng-container>
          <div class="discover-power-heading align-c">
            {{ _getStartedData?.header }}
          </div>
        </ng-container>
        <div class="landing-btn align-c">
          <a
            href="{{ _getStartedData?.button1?.url | urlParams:queryParams}}"
            target="{{ getStartedData?.button1?.target }}"
            class="btn btn-full"
            *ngIf="_getStartedData?.button1?.url.includes('exchange.verto')"
          >
            {{ _getStartedData?.button1.text }}
          </a>
          <a
            href="{{ _getStartedData?.button2?.fileUrl }}"
            target="_blank"
            download
            class="btn btn-outline"
          >
            {{ _getStartedData?.button2.text }}
          </a>
        </div>
      </div>
    </div>
  </div>
</section>